<div class="template-dialog">
  <header class="template-header">
    <mat-icon>bookmark_add</mat-icon>
    <h2>{{ (editing ? 'catalog.edit_template' : 'catalog.save_as_template') | translate }}</h2>
  </header>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>{{ 'editor.title' | translate }}</mat-label>
    <input matInput class="template-title" [(ngModel)]="title" required />
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>{{ 'catalog.theme' | translate }}</mat-label>
    <mat-select class="template-theme" [(ngModel)]="theme">
      @for (option of themes; track option) {
        <mat-option [value]="option">{{ themeLabel(option) | translate }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{ 'catalog.description' | translate }}</mat-label>
    <textarea matInput class="template-description" rows="3" [maxlength]="descriptionMax" [(ngModel)]="description"></textarea>
    <mat-hint align="end">{{ description.length }} / {{ descriptionMax }}</mat-hint>
  </mat-form-field>

  <footer class="template-footer">
    <lib-button color="none" textColor="muted" [text]="'form.close' | translate" (click)="cancel()"></lib-button>
    <lib-button class="save-template" icon="save" [text]="'form.save' | translate" [disabled]="!valid" (click)="save()"></lib-button>
  </footer>
</div>
